export default __webpack_public_path__ + "static/media/package_9.c01a2d4d.png";